/* globals jQuery */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupFocusTrap from './theme/focus-trap';
import setupCarousels from './theme/carousels';

jQuery( $ => {
	const $body = $( 'body' );

	setupAccordions();

	// =========================
	// ! Basic Toggles
	// =========================

	$body.on( 'click', '.js-toggle', function( event ) {
		const target = determineTarget( this );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			$body.toggleClass( `show-${ target.id }`, isOpen );

			// For additional actions during open/close
			$body.trigger( `toggle:${ target.id }:${ isOpen ? 'on' : 'off' }` );
		}
	} );

	$( '.js-close' ).click( function() {
		toggleElement( this.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Mobile Nav Focus Trap
	// =========================

	$( '[role="navigation"]' ).each( function() {
		// trap focus to items and controlling toggles
		const $items = $( this ).find( 'a, button' ).add( `[aria-controls="${ this.id }"]` );
		$( this ).attr( 'tabindex', -1 );

		setupFocusTrap( this, $items.get(), {
			ignoreCondition: () => this.style.position !== 'fixed',
		} );
	} );

	// =========================
	// ! Modals
	// =========================

	// Move modals outside of page-content
	$( '.tyrmc-modal' ).appendTo( $body );

	// Add classes to modals automatically
	$( '.tyrmc-modal' ).addClass( 'js-modal' );
	$( '.tyrmc-modal__close' ).addClass( 'js-modal-close' );
	$( '.tyrmc-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals();

	// =========================
	// ! Carousel
	// =========================

	// Prep carousel galleries for functionality
	$( '.tyrmc-showcase-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.wp-block-gallery' ).addClass( 'js-carousel-track' );
		$( this ).find( '.wp-block-image' ).addClass( 'js-carousel-slide' );
	} );

	setupCarousels();

	// =========================
	// ! Search Toggle
	// =========================

	$( '.tyrmc-searchbar' ).click( function() {
		$( this ).addClass( 'is-open' );
	} );

	$( '.tyrmc-searchbar' ).submit( function( e ) {
		const $input = $( this ).find( '.tyrmc-searchbar__input' );
		if ( ! $input.val() ) {
			e.preventDefault();
			$( this ).removeClass( 'is-open' );
			$( this ).find( '.tyrmc-searchbar__toggle' ).blur();
		}
	} );

	// click outside to close searchbar
	$( document ).click( function( e ) {
		if ( ! $( e.target ).hasClass( '.tyrmc-searchbar' ) && $( e.target ).parents( '.tyrmc-searchbar' ).length === 0 ) {
			$( '.tyrmc-searchbar' ).removeClass( 'is-open' );
		}
	} );

	// =========================
	// ! VH Hack
	// =========================

	function setVH() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Video Blocks
	// =========================

	$( '.tyrmc-video__media' ).click( function( e ) {
		e.preventDefault();
		const url = $( this ).data( 'embed' );

		const $iframe = $( `<iframe src="${ url }" frameborder="0" allowfullscreen></iframe>` );

		$( this ).next().remove();
		$iframe.insertAfter( this );
		$( this ).remove();
	} );

	// =========================
	// ! Embed Popups
	// =========================

	$( '.embed-popup' ).click( function( e ) {
		if ( this.dataset.popup && window.innerWidth >= 600 ) {
			e.preventDefault();
			const $popup = $( '<div class="tyrmc-takeover"></div>' ).html( this.dataset.popup );
			$body.append( $popup );
		}
	} );

	$body.on( 'click', '.tyrmc-takeover', function() {
		$( this ).fadeOut( function() {
			$( this ).remove();
		} );
	} );

	// =========================
	// ! Bookmark Links
	// =========================

	$( 'a.js-clipboard' ).click( e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	hrefClipboard.on( 'success', e => {
		$( e.trigger ).addClass( 'js-copied' ).text( 'Link copied!' );
	} );
} );
